import { useState } from "react";
import { categories } from "@/mocks/home";

const samples = [
  "头部社交平台处罚规则修订的前后对比",
  "新茶饮联名排队潮为何突然降温",
  "平台「底薪+佣金」新政策影响解读",
];

export default function Categories() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="topic" className="scroll-mt-24 bg-[#f4ecdf]">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-end justify-between gap-4 mb-6 flex-wrap">
          <div>
            <div className="text-xs font-semibold tracking-widest text-[#c2410c] mb-2 flex items-center gap-2">
              <i className="ri-grid-line"></i> COLUMNS
            </div>
            <h2 className="font-display text-2xl md:text-3xl font-bold text-[#241c15]">
              专题栏目 · 按主题吃瓜
            </h2>
          </div>
          <p className="text-sm text-[#8a7760] hidden md:block">
            共 {categories.reduce((a, c) => a + c.count, 0)} 篇内容已归档
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {categories.map((c, idx) => {
            const open = openIdx === idx;
            return (
              <article
                key={c.name}
                onClick={() => setOpenIdx(open ? null : idx)}
                className={`bg-white border rounded-xl p-5 cursor-pointer transition-all ${
                  open
                    ? "border-[#c2410c] ring-1 ring-[#c2410c]/20"
                    : "border-[#e5d2ba] hover:border-[#c9a576]"
                }`}
              >
                <div className="flex items-start justify-between">
                  <span
                    className={`w-11 h-11 flex items-center justify-center rounded-lg ${
                      c.hot ? "bg-[#fde8d7] text-[#c2410c]" : "bg-[#f4ecdf] text-[#a35f35]"
                    }`}
                  >
                    <i className={`${c.icon} text-2xl`}></i>
                  </span>
                  {c.hot && (
                    <span className="text-[9px] font-semibold text-[#fff7ed] bg-orange-500 rounded px-1.5 py-0.5">
                      热
                    </span>
                  )}
                </div>
                <h3 className="text-base font-semibold text-[#241c15] mt-4">{c.name}</h3>
                <p className="text-[12px] text-[#9a8772] mt-1">{c.desc}</p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-[11px] text-[#a08b73]">{c.count} 篇归档</span>
                  <i
                    className={`ri-arrow-down-s-line text-[#c2410c] transition-transform ${
                      open ? "rotate-180" : ""
                    }`}
                  ></i>
                </div>
                {open && (
                  <div className="mt-3 pt-3 border-t border-[#f0e5d6]">
                    <p className="text-[11px] text-[#c2410c] font-medium mb-1.5">近期跟进选题</p>
                    <ul className="space-y-1">
                      {samples.slice(0, idx % 3 + 1).map((t, i) => (
                        <li key={i} className="flex gap-1.5 text-[12px] leading-5 text-[#6b5d4d]">
                          <i className="ri-circle-fill text-[5px] text-[#c2410c] mt-1.5"></i>
                          {t}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}